import Player from '@vimeo/player';
import simpleParallax from 'simple-parallax-js';

export default {
  init() {
  },
  finalize() {
    const $bannerVideoWrap = $('.banner-video-wrap');
    if ($bannerVideoWrap.length > 0) {
      const vimeoPlayer = new Player('banner-video', {
        id: $('#banner-video').data('banner-vimeo-id'),
        controls: false,
        loop: true,
        autoplay: true,
        background: true,
        byline: false,
        autopause: false,
        responsive: true,
        muted: true,
        title: false,
        portrait: false,
        pip: true,
      });

      vimeoPlayer.on('playing', function() {
        setTimeout(() => {
          $('.banner-video-overlay').addClass('hide');
        }, 300);
      });
    }

    $(window).on('scroll', function() {
      const bannerHeight = $('.global-banner').outerHeight();
      const scrollY = $(window).scrollTop();

      // When scrollY is >50% bannerHeight we want the text invisible
      let textTransparency = 1 - (scrollY / (bannerHeight / 2));

      if (textTransparency < 0) {
        textTransparency = 0;
      }

      $('.global-banner .banner-content-wrap').css({ opacity: textTransparency });
    });

    // const $bannerImageWrap = $('.banner-image-wrap');
    // if ($bannerImageWrap.length > 0) {
    //   var bannerImage = $bannerImageWrap.find('.banner-image').get()[0];
    //   new simpleParallax(bannerImage, {
    //     scale: 1.3,
    //   });
    // }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/banner.js